
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule} from '@angular/forms'
import {RouterModule} from "@angular/router";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatButtonModule} from "@angular/material/button";
import {MatSelectModule} from "@angular/material/select";
import {FuseSidebarModule} from "../../../@fuse/components";
import {CustomerSourceMainSidebarComponent} from "./sidebars/main/main-sidebar.component";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {MatRippleModule} from "@angular/material/core";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {CustomerSourceComponent} from "./customerSource.component";
import {CustomerSourceFormComponent} from "./customerSourceForm.component";
import {TranslateModule} from "@ngx-translate/core";
import {SecurityModule} from "../security/security.module";

@NgModule({
    declarations: [
        CustomerSourceComponent,
        CustomerSourceFormComponent,
        CustomerSourceMainSidebarComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        FlexLayoutModule,
        MatSelectModule,
        MatCheckboxModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        TranslateModule,
        SecurityModule

    ],
    providers: [],
    bootstrap: [CustomerSourceComponent, CustomerSourceFormComponent]
})
export class CustomerSourceModule { }
